export default [
  {
    name: "Resignation",
    icon: "exit_to_app",
    to: "/exit",
    enabled: true,
  },
];
